// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserUpdateUserIdUpdateUserResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserUpdateUserIdUpdateUserResponse.attributeTypeMap;
    }
}
AuthenticationV2UserUpdateUserIdUpdateUserResponse.discriminator = undefined;
AuthenticationV2UserUpdateUserIdUpdateUserResponse.additionalProperties = false;
AuthenticationV2UserUpdateUserIdUpdateUserResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=authenticationV2UserUpdateUserIdUpdateUserResponse.js.map